import React from 'react'
import './About.css'

const About = () => {
  return (
    <>
    <div className="ui segment">
      <ul>
        <li>React.js</li>
        <li>Ruby on Rails</li>
        <li>Javascript</li>
        <li>HTML5</li>
        <li>CSS</li>
        <li>BootStrap</li>
        <li>JQuery</li>
        <li>Git</li>
      </ul>
    </div>
    </>
  );
}

export default About;